import { render, staticRenderFns } from "./CoffeeDelivery.vue?vue&type=template&id=1c7dc808&"
import script from "./CoffeeDelivery.vue?vue&type=script&lang=js&"
export * from "./CoffeeDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports